import type { RegionCardProps } from './RegionCard.types'
import { IconCell } from '../icon-cell'
import { Typography } from '../typography'
import styles from './RegionCard.module.css'

function RegionCard({
  src,
  alt,
  aspectRatio,
  text,
  textAs,
  imageSlot,
}: RegionCardProps) {
  return (
    <div className={styles.wrapper}>
      {imageSlot({ src, alt, aspectRatio })}
      <div className={styles.textBox}>
        <Typography as={textAs} variant="body-m-regular-tight">
          {text}
        </Typography>
        <IconCell glyph="ChevronRightExtraSmall" />
      </div>
    </div>
  )
}

export default RegionCard
